import { getDisplayDecision } from './getDisplayDecision';
import type { PortalViewId } from './portalViewIds';
import type { DisplayContext, PortalUser } from './types';

export function shouldDisplay(
  portalUser: PortalUser,
  viewId?: PortalViewId,
  context?: DisplayContext
): boolean {
  return getDisplayDecision(portalUser, viewId, context).shouldDisplay;
}
